import { useState, useEffect } from "react";
import { ActionCell } from "./GridCells";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";

export default function AgGridTable({
    columns, perPage = 10, refreshCounter, getTableRows, onCellClicked = () => { },
    hasActionButtons = false
}) {
    const rowHeight = 38;
    const [gridApi, setGridApi] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
    }

    if (hasActionButtons) {
        if (!columns.some((c) => c.headerName === "Actions"))
            columns.unshift({
                headerName: "Actions",
                resizable: true,
                minWidth: 200,
                cellRenderer: (params) => <ActionCell params={params} />,
            });
    }

    useEffect(() => {
        if (gridApi) {
            const dataSource = {
                getRows: async (params) => {
                    gridApi.showLoadingOverlay();
                    const { rows, error } = await getTableRows();
                    gridApi.hideOverlay();
                    if (error) {
                        params.successCallback([]);
                    } else {
                        params.successCallback(rows, rows.length)
                    }
                }
            }
            gridApi.setDatasource(dataSource);
        }
    }, [gridApi, refreshCounter])

    return (
        <div
            aria-live="polite"
            aria-busy={false}
            className="ag-theme-material"
        >
            <AgGridReact
                columnDefs={columns}
                pagination={false}
                rowModelType="infinite"
                paginationPageSize={perPage}
                cacheBlockSize={perPage}
                onGridReady={onGridReady}
                domLayout="autoHeight"
                headerHeight="38"
                rowHeight={rowHeight}
                defaultColDef={{
                    resizable: true,
                    flex: 1
                }}
                onCellClicked={onCellClicked}
            />
        </div>
    )
}